<section class="family-sale" *ngIf="visible" data-fs-unmask>
  <div class="family-toggle-card">
    <div class="family-toggle-card__text">
      <p class="family-toggle-card__title" id="family-sale-title">Sell as Family Plan</p>
      <p class="family-toggle-card__hint">
        Add more plates on one card. Each plate gets its own package and discount.
      </p>
    </div>
    <label class="family-switch">
      <input
        type="checkbox"
        role="switch"
        aria-labelledby="family-sale-title"
        [checked]="enabled"
        [disabled]="disabled"
        (change)="onToggleChange($event)"
      />
      <span class="family-switch__slider"></span>
    </label>
  </div>

  <ng-container *ngIf="enabled">
    <article class="family-card family-card--primary">
      <header class="family-card__head">
        <h4 class="family-card__title">{{ primaryPackageName }}</h4>
        <span class="family-pill family-pill--primary">Primary</span>
      </header>
      <dl class="family-card__grid">
        <div class="family-card__item">
          <dt>License plate</dt>
          <dd>
            <span class="family-plate">{{ primaryPlate || '-' }}</span>
          </dd>
        </div>
        <div class="family-card__item">
          <dt>Customer name</dt>
          <dd>{{ primaryCustomerName || '-' }}</dd>
        </div>
        <div class="family-card__item">
          <dt>Vehicle name</dt>
          <dd>{{ primaryVehicleName || '-' }}</dd>
        </div>
        <div class="family-card__item">
          <dt>Phone number</dt>
          <dd>{{ primaryPhone || '-' }}</dd>
        </div>
        <div class="family-card__item family-card__item--price">
          <dt>Price</dt>
          <dd>{{ money(primaryListPrice) }}</dd>
        </div>
      </dl>
    </article>

    <article class="family-card" *ngFor="let member of members; trackBy: trackById">
      <header class="family-card__head">
        <h4 class="family-card__title">{{ memberPackageName(member) }}</h4>
        <button
          type="button"
          class="family-link-btn family-card__edit"
          [disabled]="disabled || formOpen"
          [attr.aria-label]="'Edit ' + member.plate"
          (click)="editMember(member.localId)"
        >
          Edit
        </button>
        <button
          type="button"
          class="family-card__remove"
          [disabled]="disabled"
          [attr.aria-label]="'Remove ' + member.plate + ' from the family'"
          (click)="removeMember(member.localId)"
        >
          Remove
        </button>
      </header>
      <dl class="family-card__grid">
        <div class="family-card__item">
          <dt>License plate</dt>
          <dd>
            <span class="family-plate">{{ member.plate }}</span>
          </dd>
        </div>
        <div class="family-card__item">
          <dt>Customer name</dt>
          <dd>{{ memberFullName(member) || '-' }}</dd>
        </div>
        <div class="family-card__item">
          <dt>Phone number</dt>
          <dd>{{ member.phone || '-' }}</dd>
        </div>
      </dl>
      <div class="family-card__discount-row">
        <div class="family-discount">
          <span class="family-discount__label">Discount</span>
          <mat-select
            class="form-select family-discount__select"
            panelClass="family-discount-panel"
            disableOptionCentering
            [attr.aria-label]="'Discount for ' + member.plate"
            [disabled]="disabled"
            [ngModel]="member.discountValue"
            (ngModelChange)="onMemberDiscountChange(member.localId, $event)"
          >
            <mat-option *ngFor="let value of presets" [value]="value">{{
              discountLabel(value)
            }}</mat-option>
          </mat-select>
        </div>
        <div class="family-price">
          <span class="family-price__label">Price</span>
          <span class="family-price__value">{{ money(memberRecurringPrice(member)) }}/mo</span>
          <s class="family-price__was">{{ money(memberListPrice(member)) }}/mo</s>
        </div>
      </div>
    </article>

    <article class="family-card family-form" *ngIf="formOpen">
      <h4 class="family-card__title">
        {{ editingId ? 'Edit family member' : 'Add family member' }}
      </h4>
      <app-family-member-form
        idPrefix="family-member"
        [model]="form"
        [errors]="errors"
        [states]="states"
        [packages]="packageOptions"
        [discounts]="discountOptions"
        [price]="formPrice"
        [disabled]="disabled"
      />
      <div class="family-form__actions">
        <button type="button" class="family-link-btn" (click)="cancelForm()">Cancel</button>
        <button
          type="button"
          class="family-outline-btn"
          [disabled]="disabled"
          (click)="saveMember()"
        >
          Save
        </button>
      </div>
    </article>

    <button
      type="button"
      class="family-add-btn"
      *ngIf="!formOpen && canAdd"
      [disabled]="disabled"
      (click)="openForm()"
    >
      + Add family member
    </button>
    <p class="family-limit" *ngIf="!formOpen && atLimit">
      Maximum of {{ maxVehicles }} vehicles reached.
    </p>
  </ng-container>
</section>
